export const API_URL = process.env.REACT_APP_MONOLITH_API_URL;

export const ENDPOINTS = {
  init: '/v1/claim-page',
  oneLinkInit: (oneLinkId: string) => `/v1/claim-page/${oneLinkId}`,
  updateAddress: '/v1/claim-page/send',
  createOneLinkEngagement: '/v1/claim-page/one-link',
  authorizeReceiver: '/v1/claim-page/authorize',
  // Claim-scoped marketplace proxies (EX-6400, see .claude/tasks/CLAIM_PAGE_MARKETPLACE.md). The
  // claim identifiers travel as query params, as on the form-data endpoints; prices arrive as credits.
  marketplaceCatalog: '/v1/claim-page/marketplace/catalog',
  marketplaceCategories: '/v1/claim-page/marketplace/categories',
  marketplaceProduct: (productId: string) => `/v1/claim-page/marketplace/details/${productId}`,
};

export const IFRAME_ALLOWED_ORIGINS = process.env.REACT_APP_IFRAME_ORIGIN?.split(',') || [];

if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_IFRAME_ORIGIN) {
  console.warn('[iframe] REACT_APP_IFRAME_ORIGIN is not set — all iframe messages will be rejected');
}
